import { render, staticRenderFns } from "./addressbook.vue?vue&type=template&id=9b55d23c&scoped=true"
import script from "./addressbook.vue?vue&type=script&lang=js"
export * from "./addressbook.vue?vue&type=script&lang=js"
import style0 from "./addressbook.vue?vue&type=style&index=0&id=9b55d23c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b55d23c",
  null
  
)

export default component.exports